import { render, staticRenderFns } from "./ContactsDetailsIcon.vue?vue&type=template&id=4f7dfdef&"
import script from "./ContactsDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./ContactsDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports